import React from 'react'
import { Label } from "../../styles/Label";
import { ErrorText } from "./TextError";
import { TextArea } from '../../styles/Inputs';

type CustomTextAreaProps = JSX.IntrinsicElements['textarea'] & {
  label?: string;
  name: string;
  id?: string;
  type?: string;
  touched: boolean | undefined;
  errors: string | undefined;
}



export const TextAreaField = ({ label, name, touched, errors, ...props }: CustomTextAreaProps): JSX.Element => {
  return (
    <>
      <Label htmlFor={props.id || name}>{label}</Label>
      <TextArea
        id={name}
        name={name}
        {...props}
        error={touched && errors}
      />
      {touched && errors ? (
        <ErrorText>{errors}</ErrorText>
      ) : null}
    </>
  )
}